export class CreateUpdateCompaniesSubscriptionEntity {
    startDate?: string
    endDate?: string | null
}